import backgroundMusicUrl from '../../design/Vejles Koder Nynne.mp3?url';

export const audioAssets = {
  backgroundMusic: {
    id: 'vejles-koder-nynne',
    url: backgroundMusicUrl,
    loop: true,
  },
} as const;
